module.exports = __webpack_public_path__ + "static/media/background_2.b0312cd5.jpg";